import EnterpriseMetricCard from "../../../enterprise/components/EnterpriseMetricCard";

export default function WorkforceSummary({
  workforceUsers = [],
}) {
  const ready = workforceUsers.filter(
    (u) =>
      String(u.workerStatus || "").toLowerCase() === "ready" ||
      String(u.status || "").toLowerCase() === "active"
  ).length;

  const available = workforceUsers.filter(
    (u) => !u.currentShiftId
  ).length;

  const assigned = workforceUsers.filter(
    (u) => !!u.currentShiftId
  ).length;

  const expiring = workforceUsers.filter(
    (u) => String(u.complianceStatus || "").toLowerCase() === "expiring"
  ).length;

  const inactive = workforceUsers.filter(
    (u) => String(u.status || "").toLowerCase() !== "active"
  ).length;

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px,1fr))",
        gap: 10,
      }}
    >
      <EnterpriseMetricCard
        title="Ready"
        value={ready}
        subtitle="Available for scheduling"
        color="success"
      />

      <EnterpriseMetricCard
        title="Available"
        value={available}
        subtitle="Not on shift"
        color="primary"
      />

      <EnterpriseMetricCard
        title="Assigned"
        value={assigned}
        subtitle="Currently assigned"
        color="info"
      />

      <EnterpriseMetricCard
        title="Expiring"
        value={expiring}
        subtitle="Credentials expiring"
        color="warning"
      />

      <EnterpriseMetricCard
        title="Inactive"
        value={inactive}
        subtitle="Needs attention"
        color="danger"
      />
    </div>
  );
}